import $ from 'jquery'
import moment from 'moment';
import he from 'he';

/**
 * Constants
 * ====================================================
 */
const NAME = 'AppUtils'
const TM = 20 * 60000 // 20 minuti

const SELECTOR_MSGDIALOG = '#_msgdialog'
const SELECTOR_MENU = '#mnu-sidebar'
const SELECTOR_NAVLINK = '.sidebar .nav-link'
const SELECTOR_HEADER = '.navbar-nav.ml-auto'

let fn = {};
let resultaccess = undefined;
let nxpath = "";
let nxtimeoutlogout = undefined;
let nxtimeoutsession = undefined;

fn.logout = function () {
    var strtoken = JSON.stringify([]);
    window.localStorage.setItem('token', strtoken);
    window.open(nxpath + "login.html", '_top');
}

fn.checkpage = function(al, type) {
    var url = new URL(location.href);
    var path = url.pathname;
    var pagesize = path.split("/").length - 1;
    var page = (path.split("/")[pagesize]).replace(".html", "");
    switch(page) {
        /*case "answer":
            break;*/
        case "users":
        case "users-detail":
            if (al == 0) window.open(nxpath + "index.html", '_top');
            break;
        case "handler":
            if (type != "Gestore") window.open(nxpath + "index.html", '_top');
            break;
    }
}

fn.verifyLogin = function () {
    var find = false;
    var objtoken = window.localStorage.getItem('token');
    var arrtoken = (objtoken === null || objtoken == '') ? [] : JSON.parse(objtoken);

    if (arrtoken.length > 0) {
        var code = arrtoken[0].code;
        var tmpcode = fn.unconvertstring(code);
        tmpcode = tmpcode.split("|");
        if (tmpcode.length == 5) {
            fn.checkpage(tmpcode[1], tmpcode[4]);
            tmpcode = tmpcode[2];
            var tmptime = fn.unconvertnum(tmpcode);
            if (tmptime.toString().length == 10) {
                var actual = moment().unix();
                if ((actual - tmptime) < (TM / 1000)) {
                    find = true;
                }
            }
        }
    }

    if (!find) {
        fn.logout();
    }
    else {
        fn.checkTimeout();
        /*window.addEventListener('beforeunload', e => {
            var strtoken = JSON.stringify([]);
            window.localStorage.setItem('token', strtoken);
        });*/
        window.addEventListener('mousemove', e => {
            if (nxtimeoutlogout === undefined) {
                clearTimeout(nxtimeoutsession);
                fn.checkTimeout();
            }
        });
    }
}

fn.checkTimeout = function () {
    nxtimeoutlogout = undefined;
    nxtimeoutsession = setTimeout(function() {
        fn.showMsgTimeout();
    }, TM);

    var objtoken = window.localStorage.getItem('token');
    var arrtoken = (objtoken === null || objtoken == '') ? [] : JSON.parse(objtoken);

    if (arrtoken.length > 0) {
        var code = arrtoken[0].code;
        var tmpcode = fn.unconvertstring(code);
        tmpcode = tmpcode.split("|");

        var time = fn.convertnum(moment().unix());
        tmpcode[2] = time;
        var code = fn.convertstring(tmpcode.join("|"));
        arrtoken[0].code = code;
        var strtoken = JSON.stringify(arrtoken);
        window.localStorage.setItem('token', strtoken);
    }
}

fn.showMsgTimeout = function () {
    var sec_logout = 30; // secondi

    nxtimeoutlogout = setTimeout(function() {
        fn.logout();
    }, sec_logout * 1000);

    var title = "Controllo Sessione";
    var body = "Attenzione, tra " + sec_logout + " secondi sar&agrave; eseguito il Logout automatico. Premere OK per annullare il Logout.";
    var btn = {"1": "OK"};
    var param = {objlogout: nxtimeoutlogout};
    nxUtils.MsgDialogCustom(title, body, nxUtils.MsgDialogType.Warning, btn, undefined, undefined, param).then(function (value) {
        clearTimeout($(SELECTOR_MSGDIALOG).data("param").objlogout);
        fn.checkTimeout();
    });
}

fn.convertstring = function (str) {
    var result = "";

    for (var i = 0; i < str.length; i++) {
        result += str.charCodeAt(i);
    }

    return result
}

fn.unconvertstring = function (str) {
    var result = "";
    var n = "";

    for (var i = 0; i < str.length; i++) {
        n += str.charAt(i);
        var tmpn = parseInt(n);
        if (tmpn >= 32 && tmpn <= 126) {
            n = "";
            result += String.fromCharCode(tmpn);
        }
    }

    return result;
}

fn.convertnum = function (num) {
    var result = "";
    var chr = ['a', '.', 'p', ',', 'q', '-', 'g', '_', 's', '!'];
    var numstr = num.toString();

    for (var i = 0; i < numstr.length; i++) {
        var n = parseInt(numstr.charAt(i));
        result += chr[n];
    }

    return result;
}

fn.unconvertnum = function (strnum) {
    var result = "";
    var chr = ['a', '.', 'p', ',', 'q', '-', 'g', '_', 's', '!'];

    for (var i = 0; i < strnum.length; i++) {
        var l = strnum.charAt(i);
        var n = chr.indexOf(l);
        if (n > -1) result += n;
    }
    n = parseInt(n);

    return result;
}

fn.regaccess = function () {
    var username = $('#user').val().toLowerCase().trim();
    var time = fn.convertnum(moment().unix());
    var code = fn.convertstring(username + '|' + resultaccess.su + '|' + time + '|' + resultaccess.name + '|' + resultaccess.type);
    var arrtoken = [];
    arrtoken.push({ 'token': resultaccess.token, 'code': code, 'configPortal': ''});
    var strtoken = JSON.stringify(arrtoken);
    window.localStorage.setItem('token', strtoken);

    var configPortal = nxUtils.executequery(IP_SERVER_PLATFORM + '/Access/getConfigPortal', false, undefined);
    if (configPortal !== undefined) {
      arrtoken[0].configPortal = fn.convertstring(JSON.stringify(configPortal));
      var strtoken = JSON.stringify(arrtoken);
      window.localStorage.setItem('token', strtoken);
      window.open("index.html", '_top');
    } else {
      $('#loaderLogin').hide();
      nxUtils.toast.error("ATTENZIONE!!!", "Errore in fase di Login.");
    }
}

/**
 * Class Definition
 * ====================================================
 */
class AppUtils {
    constructor() {

    }

    static _handlesession () {
        $("#appversion").html(appversion);
        nxpath = location.href.indexOf("pages") == -1 ? "" : "../";
        fn.verifyLogin();
    }

    static _handleaccess (u) {
        var result = "";
        var username = $('#user').val().toLowerCase().trim();
        var data = {
          'username': username,
          'password': $('#password').val(),
          'uuid': u
        }

        resultaccess = nxUtils.executequery(IP_SERVER_PLATFORM + '/Access/login', false, data);
        if (resultaccess !== undefined) {
            if (resultaccess.token != '') {
                result = "OK";
                if (resultaccess.chk == 1) {
                  $("#firstlogin").css("display", "none");
                  $("#changepwd").css("display", "block");
                } else if (resultaccess.validateEmail == 1) {
                  $('#errorRegistration').css('display', 'block');
                } else {
                  fn.regaccess();
                }
            }
            else {
              result = "ERR";
            }
        }

        return result;
    }

    static _confirm () {
        var result = "";
        var username = $('#user').val().toLowerCase().trim();
        var data = {
          'username': username,
          'pwd0': $('#password').val(),
          'pwd1': $('#password1').val(),
          'pwd2': $('#password2').val(),
        }

        var strongRegex = new RegExp("^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[+-/:;@*%|/\!$&=?^_///)/(])(?=.{8,})");
        if (strongRegex.test(data.pwd1)) {
            var resultconfirm = nxUtils.executequery(IP_SERVER_PLATFORM + '/Access/confirm', false, data);
            if (resultconfirm !== undefined) {
                if (resultconfirm != '') {
                    result = "OK";
                    fn.regaccess();
                }
                else {
                    result = "ERR";
                }
            }
        }
        else {
            result = "ERR-PWD";
        }

        return result;
    }

    static _request () {
        var result = "";
        var email = $('#emaillost').val().trim();
        var data = {
          'email': email
        }

        var resultrequest = nxUtils.executequery(IP_SERVER_PLATFORM + '/Access/request', false, data);
        if (resultrequest !== undefined) {
            if (resultrequest != '') {
                result = resultrequest;
            } else {
                result = "ERR";
            }
        }

        return result;
    }

    static _render () {
        var objtoken = window.localStorage.getItem('token');
        var arrtoken = (objtoken === null || objtoken == '') ? [] : JSON.parse(objtoken);

        if (arrtoken.length > 0) {
            var code = arrtoken[0].code;
            var tmpcode = fn.unconvertstring(code);
            tmpcode = tmpcode.split("|");

            var configPortal = arrtoken[0].configPortal;
            var tmpConfigPortal = fn.unconvertstring(configPortal);
            tmpConfigPortal = JSON.parse(tmpConfigPortal);

            var htmlheader = '<li class="nav-item dropdown">';
            htmlheader += '<a class="nav-link" data-toggle="dropdown" href="#"><i class="far fa-comments" style="color: #ffffff"></i><span class="badge badge-danger navbar-badge">0</span></a>';
            htmlheader += '</li>';
            htmlheader += '<li class="nav-item dropdown user-menu">';
                htmlheader += '<a href="#" class="nav-link dropdown-toggle" data-toggle="dropdown" aria-expanded="false"><span class="d-md-inline" style="color: #ffffff;">' + he.decode(tmpcode[3]) + '</span></a>';
                htmlheader += '<ul class="dropdown-menu dropdown-menu-lg dropdown-menu-right" style="left: inherit; right: 0px; border-radius: 4px; min-width: 0; max-width: 170px;">';
                    htmlheader += '<li class="user-body" style="border-top: 0;">';
                        htmlheader += '<div class="row" style="padding-bottom: 5px;">';
                            htmlheader += '<div class="col-12">';
                                htmlheader += '<i class="right fas fa-user"></i>';
                                htmlheader += '<a href="' + nxpath + 'pages/profile.html" style="padding-left: 10px;">Profilo</a>';
                            htmlheader += '</div>';
                        htmlheader += '</div>';
                        htmlheader += '<div class="row">';
                            htmlheader += '<div class="col-12">';
                                htmlheader += '<i class="right fas fa-sign-out"></i>';
                                htmlheader += '<a href="#" style="padding-left: 6px;" onclick="$(document).AppUtils.Logout()">Logout</a>';
                            htmlheader += '</div>';
                        htmlheader += '</div>';
                    htmlheader += '</li>';
                htmlheader += '</ul>';
            htmlheader += '</li>';

            $(SELECTOR_HEADER).html(htmlheader);

            var html = '<li class="nav-item"><a id="menuRequestService" href="' + nxpath + 'pages/requests.html" class="nav-link"><i class="nav-icon fa-regular fa-calendar-plus"></i><p>Prenotazione Servizi</p></a></li>';

            if(tmpConfigPortal.locationId == 19938){
              html += '<li class="nav-item"><a href="#" id="menuEcocenter" class="nav-link"><i class="nav-icon fa-solid fa-recycle"></i><p>Centro di Raccolta<i class="right fas fa-angle-left"></i></p></a>';
              html += '<ul class="nav nav-treeview">'+
                '<li class="nav-item">'+
                  '<a id="menuEcocenterDelivery" href="' + nxpath + 'pages/ecocenterDelivery.html" class="nav-link">'+
                    '<i class="nav-icon fa-regular fa-rectangle-list"></i>'+
                    '<p>Conferimenti</p>'+
                  '</a>'+
                '</li>'+
                '<li class="nav-item">'+
                  '<a id="menuEcocenterDelivery" href="' + nxpath + 'pages/usersAdditionalCodes.html" class="nav-link">'+
                    '<i class="nav-icon fa-solid fa-user-plus"></i>'+
                    '<p>CF accesso CCR</p>'+
                  '</a>'+
                '</li>'+
              '</ul></li>';

              html += '<li class="nav-item"><a id="menuCollectionDetails" href="' + nxpath + 'pages/collectionDetails.html" class="nav-link"><i class="nav-icon fa-solid fa-trash-can"></i></i></i><p>Svuotamenti</p></a></li>';
              html += '<li class="nav-item"><a id="menuD2DUsers" href="' + nxpath + 'pages/d2DUsers.html" class="nav-link"><i class="nav-icon fa-solid fa-users"></i></i></i><p>Utenze Attive Collegate</p></a></li>';
            }
            /*html += '<li class="nav-item">';
                html += '<a href="#" class="nav-link"><i class="nav-icon fas fa-question-circle"></i><p>Questionari<i class="right fas fa-angle-left"></i></p></a>';
                html += '<ul class="nav nav-treeview">';
                    html += '<li class="nav-item"><a href="' + nxpath + 'pages/answer-money.html" class="nav-link"><i class="far fa-circle nav-icon"></i><p>Gestione Tariffa</p></a></li>';
                    html += '<li class="nav-item"><a href="' + nxpath + 'pages/answer-rubbish.html" class="nav-link"><i class="far fa-circle nav-icon"></i><p>Gestione Raccolta</p></a></li>';
                    html += '<li class="nav-item"><a href="' + nxpath + 'pages/answer-clean.html" class="nav-link"><i class="far fa-circle nav-icon"></i><p>Gestione Spazzamento</p></a></li>';
                html += '</ul>';
            html += '</li>';*/

            $(SELECTOR_MENU).html(html);

            if (nxpath != "") {
                var tmplink = location.href.split("/");
                var pos = tmplink.length - 1;
                var filepage = tmplink[pos];
                filepage = filepage.replace("-detail", "");
                var objlink = $(SELECTOR_NAVLINK + "[href*='" + filepage + "']");
                objlink.addClass("active");
                var checkparent = objlink.parent().parent().hasClass("nav-pills");
                if (!checkparent) {
                    objlink.parent().parent().css("display", "block");
                    var objparent = objlink.parent().parent().parent();
                    objparent.addClass("menu-open");
                    objparent.children("a").addClass("active");
                }
            }
        }
    }

    static _gettoken () {
        var objtoken = window.localStorage.getItem('token');
        var arrtoken = (objtoken === null || objtoken == '') ? [] : JSON.parse(objtoken);
        var token = arrtoken.length == 0 ? "" : arrtoken[0].token;
        return token;
    }

    static _getaccesslevel () {
        var objtoken = window.localStorage.getItem('token');
        var arrtoken = (objtoken === null || objtoken == '') ? [] : JSON.parse(objtoken);
        var code = arrtoken.length == 0 ? "" : fn.unconvertstring(arrtoken[0].code);
        var ac = code != "" ? code.split("|")[1] : "";
        return ac;
    }

    static _getUserLogin () {
        var objtoken = window.localStorage.getItem('token');
        var arrtoken = (objtoken === null || objtoken == '') ? [] : JSON.parse(objtoken);
        var code = arrtoken.length == 0 ? "" : fn.unconvertstring(arrtoken[0].code);
        var ac = code != "" ? code.split("|")[3] : "";
        return ac;
    }

    static _getConfigPortal () {
      var objtoken = window.localStorage.getItem('token');
      var arrtoken = (objtoken === null || objtoken == '') ? [] : JSON.parse(objtoken);
      var configPortal = arrtoken.length == 0 ? "" : fn.unconvertstring(arrtoken[0].configPortal);
      return JSON.parse(configPortal);
    }

    static _logout () {
        fn.logout();
    }

    static _jQueryInterface () {
        return {}
    }
}

/**
 * jQuery API
 * ====================================================
 */
$.fn[NAME] = AppUtils._jQueryInterface
$.fn[NAME].Constructor = AppUtils

$.fn[NAME].HandleSession = function () {
    AppUtils._handlesession();
}
$.fn[NAME].RegAccess = function (uuid) {
    return AppUtils._handleaccess(uuid);
}
$.fn[NAME].Confirm = function () {
    return AppUtils._confirm();
}
$.fn[NAME].Request = function () {
    return AppUtils._request();
}
$.fn[NAME].Render = function () {
    AppUtils._render();
}
$.fn[NAME].Logout = function () {
    AppUtils._logout();
}
$.fn[NAME].getToken = function () {
    return AppUtils._gettoken();
}
$.fn[NAME].getAccessLevel = function () {
    return AppUtils._getaccesslevel();
}
$.fn[NAME]._getUserLogin = function () {
    return AppUtils._getUserLogin();
}
$.fn[NAME].configPortal = function() {
  return AppUtils._getConfigPortal();
};


export default AppUtils
